export default __webpack_public_path__ + "static/media/roboto-v29-latin-regular.160fbc69.eot";